import csrfService from "../services/csrf.service"


export const generateCSRFToken = () => (dispatch) => {
    return csrfService.requestCSRFToken(dispatch);
}

export const updateSessionStatus = (expired) => (dispatch) => {
    return csrfService.updateSessionStatus(dispatch, expired);
}